import { Component, OnInit, Input } from '@angular/core';
import { RequestHelper } from '@helper/request.helper';
import { MandiriStorage } from '@storage/mandiri.storage';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { NavigationConstant } from '@constant/navigation.constant'
import { APIConstant } from '@constant/api.constant'
import { MessageConstant } from '@constant/message.constant';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  response: any;
  vaNumber: any;
  companyCode: any;
  customerName: any;
  amount: any;
  currency: any;
  hostname: any = environment.hostName;
  isLoading: boolean = false;

  constructor(
    private apiService: RequestHelper,
    private storage: MandiriStorage,
    private router: Router,
  ) { }

  ngOnInit() {
    let data = this.storage.data
    if (data == null) {
      this.router.navigate([NavigationConstant.MANDIRI_INQUIRY]);
    } else {
      this.customerName = data.billInfo2;
      this.amount = data.billDetails.billDetail[0].billAmount;
      this.currency = data.currency;
      this.vaNumber = data.billInfo1;
    }
  }

  goBack() {
    this.router.navigate([NavigationConstant.MANDIRI_INQUIRY]);
  }

  submitPayment() {
    this.isLoading = true;
    if (this.amount == null || this.amount.toString().length > 10) {
      this.isLoading = false;
      this.openDialog(MessageConstant.PAYMENT_FAILED);
    } else {
      var fieldName1 = 'companyCode';
      var fieldValue1 = this.vaNumber.substring(0, 5);
      var fieldName2 = 'billKey1';
      var fieldValue2 = this.vaNumber.substring(5, this.vaNumber.length);
      var fieldName3 = 'paymentAmount';
      var fieldValue3 = this.amount;
      var fieldName4 = 'currency';
      var fieldValue4 = this.currency;
      var fieldName5 = 'channelId';
      var fieldValue5 = '001';
      var object = {};

      object[fieldName1] = fieldValue1;
      object[fieldName2] = fieldValue2;
      object[fieldName3] = fieldValue3;
      object[fieldName4] = fieldValue4;
      object[fieldName5] = fieldValue5;

      this.apiService.post(environment.apiUrl + APIConstant.MANDIRI_PAYMENT, object)
          .subscribe((data) => {
        data.amount = this.amount;
        data.customerName = this.customerName;
        data.vaNumber = this.vaNumber;
        this.storage.data = data;
        this.router.navigate([NavigationConstant.MANDIRI_PAYMENT_RESULT]);
      }, (err) => this.isLoading = false);
    }
  }

  openDialog(result) {
    this.apiService.openDialog(result, NavigationConstant.MANDIRI_INQUIRY);
  }

}
